export default __webpack_public_path__ + "static/media/wrong.885f4f42.wav";